import React, { useContext, useEffect, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import BuscarGuia from "../../../components/BuscarGuia";
import GuiaInfo from "../../../components/GuiaInfo";
import SelectFile from "../../../components/selectScanFile/file";
import DigitalizacionesGuia from "../../../components/DigitalizacionesGuia";
import config from "../../../config";
import socketio from "socket.io-client";
import { CircularProgress } from "@material-ui/core";
import ACCESS from "../../../ACCESS.js";
import { AuthContext } from "../../../context/authContext.js";
import { withRouter } from "react-router-dom";

export default function Digitalizar() {
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const { hasAccess } = useContext(AuthContext)
  const [open, setOpen] = useState(false);
  const [idGuia, setIdGuia] = useState(params.id);
  const [socketId, setSocketId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let socket = socketio.connect(config.SOCKET_URL, {
      closeOnBeforeunload: false,
    });

    socket.on("connect", () => {
      handleConect(socket.id);
    });

    socket.on("scanned", handleScanned);

    return () => {
      socket.off("connect", handleConect);
      socket.off("scanned", handleScanned);
      socket.close();
    };

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (idGuia) {
      setIdGuia(params.id);
    }
    //eslint-disable-next-line
  }, [location]);

  const handleConect = (socketid) => {
    setSocketId(socketid);
  };

  const handleScanned = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  const onGuiaChange = (guia) => {
    setIdGuia(guia.id);
    history.push(`/Digitalizar/GuiaEntregada/${guia.id}`);
  };

  return (
    <div style={{ width: "100%", padding: "0px 15px" }}>
      <BuscarGuia onSelect={onGuiaChange} estado={[6]} textoBoton={'Buscar'} />
      {idGuia && <GuiaInfo idGuia={idGuia} />}

      {idGuia &&
        (!loading ? (
          <div>
            { hasAccess([ACCESS.DIGITALIZAR.ESCANEAR]) &&
              <SelectFile
                open={open}
                id_guia={idGuia}
                setOpen={setOpen}
                socketId={socketId}
              />
            }
            <DigitalizacionesGuia guiaId={idGuia} />
          </div>
        ) : (
          <CircularProgress />
        ))}
    </div>
  );
}
